// src/components/layout/Navbar.jsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { LogOut, Menu, Moon, Sun } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';
import { useTheme } from '../../context/ThemeContext';
import Logo from '../common/Logo';
import { IconButton, Pill } from '../common/ui';

const initials = (name = '') =>
  name.replace(/[^a-zA-Z0-9]/g, ' ').trim().slice(0, 2).toUpperCase() || '?';

const Navbar = ({ onMenuClick }) => {
  const { user, logout } = useAuth();
  const { isDark, toggle } = useTheme();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <header className="sticky top-0 z-40 flex h-[60px] items-center gap-3 border-b border-line bg-surface px-4 lg:px-5">
      <IconButton label="Open menu" onClick={onMenuClick} className="lg:hidden">
        <Menu className="h-5 w-5" />
      </IconButton>

      {/* The wordmark's cap height is 38.3% of the lockup's height, and its
          baseline sits at 71.7% — so at h-26 the letters are ~10px tall, which
          is what "AI Portal" is sized and weighted to match. Change one, work
          out the other; eyeballing it is what made them disagree. */}
      <div className="flex items-center gap-2.5">
        <Logo className="h-[26px]" />
        <span className="hidden h-[18px] w-px bg-line sm:block" />
        <span className="hidden translate-y-[0.5px] font-display text-[14px] font-medium leading-none tracking-tight text-ink-2 sm:inline">
          AI Portal
        </span>
      </div>

      <div className="ml-auto flex items-center gap-2">
        <IconButton label={isDark ? 'Switch to light theme' : 'Switch to dark theme'} onClick={toggle}>
          {isDark ? <Sun className="h-[18px] w-[18px]" /> : <Moon className="h-[18px] w-[18px]" />}
        </IconButton>

        <div className="flex items-center gap-2 rounded-full border border-line py-1 pl-1 pr-2">
          <span className="grid h-6 w-6 place-items-center rounded-full bg-accent-soft text-[11px] font-semibold text-accent">
            {initials(user.username)}
          </span>
          <span className="hidden text-[13px] font-medium sm:inline">{user.username}</span>
          <Pill tone={user.role === 'admin' ? 'accent' : 'neutral'} className="capitalize">
            {user.role}
          </Pill>
        </div>

        <IconButton label="Sign out" onClick={handleLogout}>
          <LogOut className="h-[18px] w-[18px]" />
        </IconButton>
      </div>
    </header>
  );
};

export default Navbar;
